import { useInitData } from '../../../hooks'
import { getChatProfilePathname } from '../../../utils/link'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewMessageRow } from '../BirdviewMessageRow'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

function BirdviewMessagesWidget({
  dragHandleProps,
  section,
  title,
  onNavigate,
}) {
  const { availableSections } = useInitData()
  const { getListTarget } = useBirdviewListTarget()

  function handleOpen(item) {
    onNavigate(getChatProfilePathname({ availableSections, uuid: item.id }))
  }

  function handleShowAll() {
    onNavigate(getListTarget(BIRDVIEW_SECTION_TARGET.dwellerMessages))
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewMessageRow item={item} key={item.id} onOpen={handleOpen} />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewMessagesWidget
